"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = exports.categories = exports.actions = void 0;
var categories = exports.categories = {
  ad: 'ad',
  web: 'web'
};
var actions = exports.actions = {
  trackingURLTimeout: 'hls.advanced.trackingURL.error.timeout',
  trackingURLError: 'hls.advanced.trackingURL.error',
  // append response code
  trackingURLEmpty: 'hls.advanced.trackingURL.empty.response',
  trackingURLStreamSwitch: 'hls.advanced.trackingURL.stream.switch',
  instreamPostTimeout: 'hls.advanced.post.error.timeout',
  instreamPostError: 'hls.advanced.post.error',
  // append response code
  instreamRequestTrackingDataError: 'instream.requestTrackingData.error',
  masterUrlTimeout: 'hls.advanced.masterUrl.error.timeout',
  masterUrlError: 'hls.advanced.masterUrl.error',
  // append response code
  mixedContentUpgrade: 'mixedContentUpgrade'
};
var labels = exports.labels = {
  fail: 'fail',
  success: 'success'
};
//# sourceMappingURL=logging.js.map